import { data_from_server_post } from '@/shared/http/client';

const noop = () => {};

/**
 * Persist one walkthrough's state on the signed-in user
 * (`POST /users/set-preferences` → `preferences.walkthroughs.<id>`).
 *
 * Fire-and-forget: the walkthrough keeps working from local state when the
 * save fails (auth disabled, offline, …), so failures are swallowed instead
 * of toasted. Resolves with the merged `preferences` or `null`.
 */
export function saveWalkthroughState(id, { status, stepId = null }) {
    return new Promise((resolve) => {
        try {
            data_from_server_post(
                'users/set-preferences',
                { walkthroughs: { [id]: { status, step_id: stepId } } },
                (result) => resolve(result?.preferences || null),
                () => resolve(null)
            ).catch(noop);
        } catch {
            resolve(null);
        }
    });
}
